import React from 'react';
import Icon from '../AppIcon';

const STATUS_MAP = {
  active: { label: 'Ativo', tone: 'bg-success/15 text-success border-success/40', icon: 'CheckCircle' },
  idle: { label: 'Ocioso', tone: 'bg-muted text-muted-foreground border-border', icon: 'PauseCircle' },
  maintenance: { label: 'Manutenção', tone: 'bg-warning/15 text-warning border-warning/40', icon: 'Wrench' },
  inactive: { label: 'Inativo', tone: 'bg-error/15 text-error border-error/40', icon: 'XCircle' },
  nonexistent: { label: 'Inexistente', tone: 'bg-muted/40 text-muted-foreground border-border', icon: 'Archive' },
};

const StatusPill = ({ status = 'idle', className = '' }) => {
  const conf = STATUS_MAP[status] || STATUS_MAP.idle;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${conf.tone} hover:ring-2 ring-border/50 ${className}`}
    >
      <Icon name={conf.icon} className="w-3.5 h-3.5" />
      {conf.label}
    </span>
  );
};

export default StatusPill;